module.exports = __webpack_public_path__ + "static/img/maisui.2dd52457.png";